<template>
  <div class="role_permission_manage_wrap">
    <div class="header">
      <el-button size="medium" type="primary" @click="saveRolePermission" :disabled="!canSelect" v-if="isShowByPermission('/wyms/srp/addModuleRolePermZ')">保存</el-button>
      <el-button size="medium" type="danger" @click="toDelPermission" :disabled="!canSelect" v-if="isShowByPermission('/wyms/srp/delModuleRolePermZ')">删除</el-button>
    </div>
    <div class="role_permission_manage_box" :style="`height: ${windowHeight - 180}px;`">
      <div class="role_permission_manage_content">
        <el-form :model="formData" ref="form" label-width="80px" class="demo-ruleForm">
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="formData.type" @change="changeType">
              <el-radio :label="0">已安装某个模块的学校</el-radio>
              <el-radio :label="1">幼儿园(处理非模块)</el-radio>
              <el-radio :label="2">中小学(处理非模块)</el-radio>
              <el-radio :label="5">教育局(处理非模块)</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="应用模块" prop="moduleId" v-if="formData.type === 0">
            <el-select v-model.trim="formData.moduleId" filterable placeholder="请选择">
              <el-option :label="item.code + '--' + item.name" :value="item.code" :key="item.id" v-for="item in moduleList"></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="resetModulePermission" :disabled="!canSelect" v-if="isShowByPermission('/wyms/srp/resetPermissionZ')">重置应用权限</el-button>
          </el-form-item>
          <el-form-item label="角色" prop="constantId">
            <el-select v-model.trim="formData.constantId" filterable placeholder="请选择">
              <el-option :label="item.name" :value="item.constantId" :key="item.id" v-for="item in roleList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择权限" prop="suiteId">
            <div class="tree-container">
              <el-tree class="filter-tree" ref="tree" :data="treeData" :props="defaultProps" node-key="id" :expand-on-click-node='false' show-checkbox @node-click="handleNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span :title="data.name">{{ data.name }}</span>
                </span>
              </el-tree>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="isShowNodeBox" :close-on-press-escape='false' width="50%"
               :lock-scroll="false" :close-on-click-modal='false' :modal-append-to-body='false' :show-close="false">
      <div class="all_suite_box">
        <div v-html="nodeText"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowNodeBox = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize'
  import {listModule, lisRole, queryPermissionTree, addModuleRolePerm, delModuleRolePerm, resetPermission} from '@/api/commonTool'

  export default {
    name: "rolePermissionManage",
    data() {
      return {
        isShowNodeBox: false,
        nodeText: '',
        canSelect: true,
        moduleList: [],
        roleList: [],
        treeData: [],
        defaultProps: {
          children: 'childrens',
          label: 'label'
        },
        formData: {
          type: 0,
          moduleId: null,
          constantId: null
        }
      }
    },
    mixins: [windowResize],
    created() {
      this.listModule();
      this.lisRole();
      this.queryPermissionTree();
    },
    methods: {
        isShowByPermission,
      listModule() {
        listModule().then(data => {
          this.moduleList = data;
          this.formData.moduleId = data[0].code;
        })
      },
      lisRole() {
        lisRole().then(data => {
          this.roleList = data;
          this.changeType();
        })
      },
      queryPermissionTree() {
        queryPermissionTree({menu: true}).then(data => {
          this.treeData = [data];
        })
      },
      changeType() {
        this.formData.constantId = null;
        this.$refs.tree.setCheckedKeys([]);
      },
      initList() {
        this.canSelect = true;
        this.formData.moduleId = this.moduleList[0].code;
        this.formData.constantId = null;
        this.$refs.tree.setCheckedKeys([]);
      },
      saveRolePermission() {
        this.$refs.form.validate(isValid => {
          if(isValid) {
            const perList = [...this.$refs.tree.getCheckedKeys().filter(key => key != 0), ...this.$refs.tree.getHalfCheckedKeys().filter(key => key != 0)];
            if (!this.formData.constantId) {
              this.$message.warning('请选择角色!');
              return;
            }
            if (!perList || !perList.length) {
              this.$message.warning('请选择权限!');
              return;
            }
            this.canSelect = false;
            new Promise(resolve => {
              addModuleRolePerm({
                constantId: this.formData.constantId,
                moduleCode: this.formData.moduleId,
                permIds: perList.toString(),
                filterVal: this.formData.type
              }).then(resolve)
            }).then(() => {
              this.$message.success('保存成功');
              this.initList();
            }).catch(err => {
              this.canSelect = true;
            })
          }
        })
      },
      toDelPermission() {
        const perList = [...this.$refs.tree.getCheckedKeys().filter(key => key != 0), ...this.$refs.tree.getHalfCheckedKeys().filter(key => key != 0)];
        if (!this.formData.constantId) {
          this.$message.warning('请选择角色!');
          return;
        }
        if (this.formData.type && (!perList || !perList.length)) {
          this.$message.warning('请选择权限!');
          return;
        }
        this.$confirm("确定要删除" + this.getRoleNameById() + "角色及" + (perList.length ? '所选对应' : '其所有') + "权限吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          this.canSelect = false;
          delModuleRolePerm({
            constantId: this.formData.constantId,
            moduleCode: this.formData.moduleId,
            permIds: perList.toString(),
            filterVal: this.formData.type
          }).then(data => {
            this.$message.success('删除成功');
            this.initList();
          }).catch(err => {
            this.canSelect = true;
          })
        });
      },
      resetModulePermission() {
        this.$confirm("确定要重置应用的所有权限和角色吗？请先维护模板", "重置", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          this.canSelect = false;
          resetPermission({moduleCode: this.formData.moduleId}).then(data => {
            this.$message.success('重置成功');
            this.initList();
          }).catch(err => {
            this.canSelect = true;
          })
        });
      },
      getRoleNameById() {
        let roleName = '';
        this.roleList.forEach((item) => {
          if (this.formData.constantId && (item.id === this.formData.constantId)) {
            roleName = item.name;
          }
        });
        return roleName;
      },
      handleNodeClick(data) {
        if (data.t) {
          this.nodeText = data.t;
          this.isShowNodeBox = true;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../styles/mixin';

  .role_permission_manage_wrap {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .role_permission_manage_box {
      @include scrollBar;

      .role_permission_manage_content {
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;
        .tree-container{
          margin-top: 8px;
        }
      }
    }
    .all_suite_box{
      @include scrollBar;
      height: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/commonTool/rolePermissionManage.vue